export default __webpack_public_path__ + "static/media/040_tunnel.vp9.9f5e0222.webm";